import React from 'react';

import { FlexBox } from '../box';
import { Skeleton } from '../skeleton';
import { styled } from '../styled';

export const changeValue = (props: {
    step: number;
    min: number;
    max: number;
    key: string;
    value?: number;
    shiftKey?: boolean;
}) => {
    const { step, value, min, max, key, shiftKey } = props;
    const newStep = shiftKey ? 10 : step;
    const defaultValue = value ?? 0;

    const newValue = (() => {
        switch (key) {
            case 'ArrowDown':
                return Number((defaultValue - newStep).toFixed(15));
            case 'ArrowUp':
                return Number((defaultValue + newStep).toFixed(15));
            default:
                return undefined;
        }
    })();

    if (newValue !== undefined) {
        return Math.min(max, Math.max(min, newValue));
    }

    return newValue;
};

const OverlaySkeleton = styled(Skeleton)({
    position: 'absolute'
});

export const fieldErrorProps = (
    error: React.ReactNode | undefined,
    helperText: React.ReactNode | undefined
) => {
    const normalizedError = typeof error === 'boolean' ? undefined : error;
    return {
        error: Boolean(error),
        helperText: normalizedError ?? helperText
    } as const;
};

export const FieldSkeleton = ({
    width,
    children
}: {
    width: string | number;
    children: React.ReactNode;
}) => (
    <FlexBox position="relative" width={width}>
        <OverlaySkeleton width="100%" height="100%" />
        <FlexBox visibility="hidden">{children}</FlexBox>
    </FlexBox>
);
